import { Injectable } from '@angular/core';

import { DataService } from '../../shared/services/data.service';
import { RiskConstantsService } from '../services/risk-constants.service';
import { ConstantsService } from '../../shared/services/constants.service';
import { BaseService } from '../../shared/services/base.service';

@Injectable()
export class RiskService {
  public updatedRiskData: any;
  public oldActionData: any;
  public oldElementData:any;
  public oldStepData:any;
  currentRiskRequestId: string;
  constructor(private dataService: DataService, private baseService:BaseService) { }

  public setAllRiskIds(allRiskIds) {
    let riskIds = [];
    allRiskIds.forEach(item => {
      riskIds.push({ 'RiskRequestId': item.RiskRequestId, 'UnitId': item.UnitId });
    });
   
    this.baseService.setItemInSession('riskIds',JSON.stringify(riskIds));
  }
  public getAllRiskIds() {
    return JSON.parse(this.baseService.getItemFromSession('riskIds'));
  }
  public setUpdatedData(data, actionType) {
    switch (actionType) {
      
      case 'UpdateAction':
        this.updatedRiskData = data;
        break;

    }
  }
  public getUpdatedData(actionType) {
    switch (actionType) {
      
      case 'UpdateAction':
        return this.updatedRiskData;
    }
  }
  public setoldActionData(data) {
    this.oldActionData = data;
  }
  public getoldActionData() {
    return this.oldActionData;
  }
  public getoldElementData() {
    return this.oldElementData;
  }
  public setoldElementData(data) {
    this.oldElementData = data;
  }
  public getoldSteptData() {
    return this.oldStepData;
  }
  public setoldStepData(data) {
    this.oldStepData = data;
  }
  public setupdatedRiskData(data) {
    this.updatedRiskData = data;
  }
  public getupdatedRiskData() {
    return this.updatedRiskData;
  }  /**
     * Function to get all master records required for raise risk
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  // service call to get action trend report data
  getAllMasterForRaiseRisk(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.GetAllMasterForRiskRaise, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
     * Function to get risk request by id
     * @param Model - Model to send data to api with RiskRequestId
     * @param callbackMethod - return the response
     */
  // service call to get action trend report data
  getRiskRequestById(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.GetRiskRequestPostEntityById, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getActionPartyByActionId(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.GetActionPartyByActionId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  /**
     * Function to get risk request by id
     * @param Model - Model to send data to api with RiskRequestId
     * @param callbackMethod - return the response
     */
  // service call to get action trend report data
  getRiskRequestForEdit(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.GetRiskRequestForEdit, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // service call to get risk data based on Risk Management Tool
  getRiskRequestForEditByTool(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.GetRiskRequestForEditByTool, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
// service call to get Tool Id
getRiskRequestForToolId(model, callbackMethod) {
  this.dataService.post(RiskConstantsService.ApiConstants.GetRiskRequestForToolId, model)
    .subscribe(response => {
      callbackMethod(response);
    });
}
  
  getIsValidForApprove(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.getIsValidForApprove, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // service call to get all the employee's name whose initial entered
  getSearchResultsForUsers(model, callbackMethod) {
    const requestData = model;
    this.dataService.post(ConstantsService.APIURL.Common.GetUsersOnSearch, requestData)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  //Function to get list of Risk Control Techniques
  getRiskControlTechniques(callbackMethod) {
    const requestData = "";
    this.dataService.post(RiskConstantsService.ApiConstants.GetRiskControlTechniques, requestData)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
     * Function to raise risk request
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  // service call to get action trend report data
  raiseRisk(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.RaiseRisk, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  //Function to raise risk for selected Tool
  raiseRiskForSelectedTool(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.RaiseRiskForSelectedTool, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  raiseBulkRiskForSelectedTool(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.RaiseBulkRiskForSelectedTool, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  ImportRiskFromExcel(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.ImportRiskFromExcel, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  ImportBulkRiskFromExcel(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.ImportBulkRiskFromExcel, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  ExportRiskToExcel(model, callbackMethod) {
    this.dataService.postHttpResponse(RiskConstantsService.ApiConstants.ExportRiskToExcel, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  //Function to perform Authorization
  authoriseJSA(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.AuthorizeRiskForJSA, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  authoriseMOC(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.AuthorizeRiskForMOC, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
     * Function to update risk request
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  // service call to get action trend report data
  updateRisk(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.UpdateRisk, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  updateRiskForSelectedTool(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.UpdateRiskForSelectedTool, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getRiskForHAZOPElementDetail(severity, likelihood) {
    switch (severity) {
      case '0':
      case 0:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
          case 3:
          case '3':  
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'L';
        }
        break;
      case '1':
      case 1:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
          case 3:
          case '3':  
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'L';
        }
        break;

      case '2':
      case 2:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
          case 3:
          case '3':  
            return 'L';
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'M';
        }
        break;
      case '3':
      case 3:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
            return 'L';
          case 3:
          case '3':  
          case 4:
          case '4':  
            return 'M';
          case 5:
          case '5':  
            return 'H';
        }
        break;

      case '4':
      case 4:
        switch (likelihood) {
          case 1:
          case '1':  
            return 'L';
          case 2:
          case '2':  
          case 3:
          case '3':  
            return 'M';
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'H';
        }
        break;

      case '5':
      case 5:
        switch (likelihood) {
          case 1:
          case '1':  
            return 'L';
          case 2:
          case '2':  
            return 'M';
          case 3:
          case '3':  
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'H';
        }
        break;
    }
    return "NA";
  }

  getInitialRiskForHAZIDElementDetail(severity, likelihood) {
    switch (severity) {
      case '0':
      case 0:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
          case 3:
          case '3':  
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'L';
        }
        break;
      case '1':
      case 1:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
          case 3:
          case '3':  
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'L';
        }
        break;

      case '2':
      case 2:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
          case 3:
          case '3':  
            return 'L';
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'M';
        }
        break;
      case '3':
      case 3:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
            return 'L';
          case 3:
          case '3':  
          case 4:
          case '4':  
            return 'M';
          case 5:
          case '5':  
            return 'H';
        }
        break;

      case '4':
      case 4:
        switch (likelihood) {
          case 1:
          case '1':  
            return 'L';
          case 2:
          case '2':  
          case 3:
          case '3':  
            return 'M';
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'H';
        }
        break;

      case '5':
      case 5:
        switch (likelihood) {
          case 1:
          case '1':  
            return 'L';
          case 2:
          case '2':  
            return 'M';
          case 3:
          case '3':  
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'H';
        }
        break;
    }
    return "NA";
  }

  getResidualRiskForHAZIDElementDetail(severity, likelihood) {
    switch (severity) {
      case '0':
      case 0:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
          case 3:
          case '3':  
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'L';
        }
        break;
      case '1':
      case 1:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
          case 3:
          case '3':  
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'L';
        }
        break;

      case '2':
      case 2:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
          case 3:
          case '3':  
            return 'L';
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'M';
        }
        break;
      case '3':
      case 3:
        switch (likelihood) {
          case 1:
          case '1':  
          case 2:
          case '2':  
            return 'L';
          case 3:
          case '3':  
          case 4:
          case '4':  
            return 'M';
          case 5:
          case '5':  
            return 'H';
        }
        break;

      case '4':
      case 4:
        switch (likelihood) {
          case 1:
          case '1':  
            return 'L';
          case 2:
          case '2':  
          case 3:
          case '3':  
            return 'M';
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'H';
        }
        break;

      case '5':
      case 5:
        switch (likelihood) {
          case 1:
          case '1':  
            return 'L';
          case 2:
          case '2':  
            return 'M';
          case 3:
          case '3':  
          case 4:
          case '4':  
          case 5:
          case '5':  
            return 'H';
        }
        break;
    }
    return "NA";
  }

  getRiskColorClass(severity, likelihood) {
    switch (severity) {
      case '0':
      case 0:
        switch (likelihood) {
          case 'A':
          case 'B':
          case 'C':
          case 'D':
          case 'E':
            return 'riskColorBlue';
        }
        break;
      case '1':
      case 1:
        switch (likelihood) {
          case 'A':
          case 'B':
          case 'C':
          case 'D':
          case 'E':
            return 'riskColorBlue';
        }
        break;

      case '2':
      case 2:
        switch (likelihood) {
          case 'A':
          case 'B':
          case 'C':
            return 'riskColorBlue';
          case 'D':
          case 'E':
            return 'riskColorYellow';
        }
        break;
      case '3':
      case 3:
        switch (likelihood) {
          case 'A':
          case 'B':
            return 'riskColorBlue';
          case 'C':
          case 'D':
          case 'E':
            return 'riskColorYellow';
        }
        break;

      case '4':
      case 4:
        switch (likelihood) {
          case 'A':
            return 'riskColorBlue';
          case 'B':
          case 'C':
            return 'riskColorYellow';
          case 'D':
          case 'E':
            return 'riskColorRed';
        }
        break;

      case '5':
      case 5:
        switch (likelihood) {
          case 'A':
          case 'B':
            return 'riskColorYellow';
          case 'C':
          case 'D':
          case 'E':
            return 'riskColorRed';
        }
        break;
    }
    return "NA";
  }
  // service call to get risk
  getRiskForDashboard(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.GetRiskForDashboard, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getAllActionByRiskRequestId(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.GetAllActionByRiskRequestId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  /**
     * Function to get risk request by risk request id
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  getRiskRequestByRiskRequestId(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.GetRiskRequestByRiskId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
     * Function to update action details for risk by action owner based on action id
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  updateActionDetailsByActionOwnerForRisk(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.UpdateActionDetailsByActionOwnerForRisk, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  deleteRiskRequest(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.DeleteRisk, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
     * Function to Get action details by action id
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  GetCompletedActionByRiskId(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.GetCompletedActionByRiskId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
     * Function to Close Request by risk request id
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  CloseRiskRequestByRiskId(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.CloseRiskRequestByRiskId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  ChangeAlphabetToNumber(character) {
    let getNumber;
    RiskConstantsService.AlphabeticalToNumber.Alphabet.forEach(alphabetNumber => {
      if (alphabetNumber.Character === character) {
        getNumber = alphabetNumber.Id;
      }
    });
    return getNumber;
  }
  /**
  * Function to Download PDF
  * @param model - Model contain ProcessId and SourceId
  * @param callbackMethod - return the response
  */
  downloadPDF(model, callbackMethod) {
    this.dataService.postHttpResponse(RiskConstantsService.ApiConstants.DownloadPDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  savePDF(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.SavePDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  UpdateActionsForRisk(model, callbackMethod) {
    this.dataService.post(RiskConstantsService.ApiConstants.UpdateActionsForRisk, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  public setcurrentRiskRequestId(riskId) {
    this.currentRiskRequestId = riskId;
}
public getcurrentRiskRequestId() {
    return this.currentRiskRequestId;
}
ExportToExcelOnRiskDashBoard(model, callbackMethod) {
  this.dataService.postHttpResponse(RiskConstantsService.ApiConstants.ExportToExcelOnRiskDashBoard, model)
    .subscribe(response => {
      callbackMethod(response);
    });
}
getRiskForApproval(model, callbackMethod) {
  this.dataService.post(RiskConstantsService.ApiConstants.GetRiskForApproval, model)
    .subscribe(response => {
      callbackMethod(response);
    });
}

}
